<template>
  <Alert type="info" show-icon :class="[prefixCls]">
    <template #message>
      <span v-if="props.count > 0">
        {{ t('component.table.selectionBarTips', { count: props.count }) }}
      </span>
      <span v-else>
        {{ t('component.table.selectionBarEmpty') }}
      </span>
      <MButton v-show="props.count > 0" type="link" size="small" @click="clearSelectedRowKeys">
        {{ t('component.table.selectionBarClear') }}
      </MButton>
    </template>
  </Alert>
</template>

<script lang="ts" setup>
  import { Alert } from 'ant-design-vue';
  import { useDesign } from '@mts/hooks/web/useDesign';
  import { t } from '@mts/hooks/web/useI18n';
  import type { TableActionType } from '../types/table';

  const { prefixCls } = useDesign('table-select-bar');

  defineOptions({
    name: 'TableSelectBar',
  });

  const props = withDefaults(
    defineProps<{
      count?: number;
      total?: number;
      //
      clearSelectedRowKeys: TableActionType['clearSelectedRowKeys'];
    }>(),
    {
      count: () => 0,
    },
  );
</script>

<style lang="less">
  @prefix-cls: ~'@{namespace}-table-select-bar';

  .@{prefix-cls}.ant-alert {
    flex-grow: 1;
    padding: 2px 8px;

    :deep(.ant-btn-link) {
      height: 20px;
      line-height: 20px;
    }
  }
</style>
